// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import {
//   doc,
//   getDoc,
//   collection,
//   query,
//   where,
//   orderBy,
//   getDocs,
//   addDoc,
//   serverTimestamp,
// } from "firebase/firestore";
// import { auth, db } from "../firebase";
// import jsPDF from "jspdf";
// import "./LogDetail.css";

// /**
//  * 🔐 PRODUCTION PUBLIC DOMAIN
//  * This is the ONLY domain that should ever be shared.
//  * Never use window.location.origin for share links.
//  */
// const PUBLIC_BASE_URL = "https://prooftap.web.app";
// // or: https://logitonce.com

// export default function LogDetail() {
//   const { logId } = useParams();

//   const [log, setLog] = useState(null);
//   const [events, setEvents] = useState([]);
//   const [note, setNote] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // 🔹 Load log + events (OWNER VIEW)
//   useEffect(() => {
//     const loadData = async () => {
//       try {
//         const logSnap = await getDoc(doc(db, "logs", logId));
//         if (!logSnap.exists()) {
//           throw new Error("Log not found");
//         }

//         setLog({ id: logSnap.id, ...logSnap.data() });

//         const q = query(
//           collection(db, "log_events"),
//           where("log_id", "==", logId),
//           orderBy("timestamp", "asc")
//         );

//         const snap = await getDocs(q);
//         setEvents(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
//       } catch (err) {
//         console.error(err);
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     loadData();
//   }, [logId]);

//   // 🔗 Share link — PRODUCTION SAFE
//   const handleShare = async () => {
//     const shareUrl = `${PUBLIC_BASE_URL}/l/${logId}`;
//     await navigator.clipboard.writeText(shareUrl);
//     alert("Public share link copied");
//   };

//   // 📝 Add note (OWNER ACTION)
//   const handleAddNote = async () => {
//     if (!note.trim()) return;

//     const ref = await addDoc(collection(db, "log_events"), {
//       log_id: logId,
//       event_type: "NOTE_ADDED",
//       actor: auth.currentUser.uid,
//       timestamp: serverTimestamp(),
//       metadata: { note },
//     });

//     setEvents((prev) => [
//       ...prev,
//       {
//         id: ref.id,
//         log_id: logId,
//         event_type: "NOTE_ADDED",
//         actor: auth.currentUser.uid,
//         timestamp: { toDate: () => new Date() },
//         metadata: { note },
//       },
//     ]);

//     setNote("");
//   };

//   // 📄 Export PDF (OWNER ACTION)
//   const handleExportPDF = async () => {
//     const pdf = new jsPDF();

//     pdf.text(`Log: ${log.title}`, 10, 20);
//     pdf.text(`Created: ${formatDate(log.created_at)}`, 10, 30);
//     pdf.text(`Expires: ${formatDate(log.expiry_at)}`, 10, 40);

//     let y = 60;
//     events.forEach((e) => {
//       pdf.text(
//         `${e.event_type} — ${formatDate(e.timestamp)}`,
//         10,
//         y
//       );
//       y += 10;
//     });

//     pdf.save(`log-${logId}.pdf`);

//     const ref = await addDoc(collection(db, "log_events"), {
//       log_id: logId,
//       event_type: "EXPORTED",
//       actor: auth.currentUser.uid,
//       timestamp: serverTimestamp(),
//     });

//     setEvents((prev) => [
//       ...prev,
//       {
//         id: ref.id,
//         log_id: logId,
//         event_type: "EXPORTED",
//         actor: auth.currentUser.uid,
//         timestamp: { toDate: () => new Date() },
//       },
//     ]);
//   };

//   if (loading) return <p style={{ padding: 40 }}>Loading…</p>;
//   if (error) return <p style={{ padding: 40, color: "red" }}>{error}</p>;

//   return (
//     <div className="signup-wrapper">
//       <div className="yellow-circle"></div>

//       <div className="signup-card log-detail-card">
//         <h1>{log.title}</h1>

//         <div className="meta">
//           <p><strong>Created:</strong> {formatDate(log.created_at)}</p>
//           <p><strong>Expires:</strong> {formatDate(log.expiry_at)}</p>
//         </div>

//         <hr />

//         <h3>Timeline</h3>

//         <ul className="timeline">
//           {events.map((e) => (
//             <li key={e.id}>
//               <strong>{e.event_type}</strong>
//               <span>{formatDate(e.timestamp)}</span>
//               {e.metadata?.note && (
//                 <div className="note-box">{e.metadata.note}</div>
//               )}
//             </li>
//           ))}
//         </ul>

//         <div className="actions">
//           <button onClick={handleShare}>Share Link</button>
//           <button onClick={handleExportPDF}>Export PDF</button>
//         </div>

//         <div className="input-group">
//           <textarea
//             className="note-input"
//             placeholder="Add a note"
//             value={note}
//             onChange={(e) => setNote(e.target.value)}
//           />
//         </div>

//         <button className="signup-btn" onClick={handleAddNote}>
//           Add Note
//         </button>
//       </div>
//     </div>
//   );
// }

// // 🔹 Helper
// function formatDate(ts) {
//   if (!ts) return "—";
//   return ts.toDate().toLocaleString();
// }


























// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import {
//   doc,
//   getDoc,
//   collection,
//   query,
//   where,
//   orderBy,
//   getDocs,
//   addDoc,
//   serverTimestamp,
// } from "firebase/firestore";
// import { auth, db } from "../firebase";
// import jsPDF from "jspdf";
// import "./LogDetail.css";

// /**
//  * 🔐 PRODUCTION PUBLIC DOMAIN
//  * This is the ONLY domain that should ever be shared.
//  */
// const PUBLIC_BASE_URL = " https://prooftap-f7ca4.web.app";

// export default function LogDetail() {
//   const { logId } = useParams();

//   const [log, setLog] = useState(null);
//   const [events, setEvents] = useState([]);
//   const [note, setNote] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // 🔹 Load log + timeline (OWNER VIEW)
//   useEffect(() => {
//     const loadData = async () => {
//       try {
//         const logRef = doc(db, "logs", logId);
//         const logSnap = await getDoc(logRef);

//         if (!logSnap.exists()) {
//           throw new Error("Log not found");
//         }

//         const logData = { id: logSnap.id, ...logSnap.data() };

//         // 🔴 Safety check
//         if (!logData.public_id) {
//           throw new Error("Public link not generated for this log");
//         }

//         setLog(logData);

//         const q = query(
//           collection(db, "log_events"),
//           where("log_id", "==", logId),
//           orderBy("timestamp", "asc")
//         );

//         const snap = await getDocs(q);
//         setEvents(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
//       } catch (err) {
//         console.error(err);
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     loadData();
//   }, [logId]);

//   // 🔗 Share link — PRODUCTION SAFE
//   const handleShare = async () => {
//     if (!log?.public_id) {
//       alert("Public link not available");
//       return;
//     }

//     const shareUrl = `${PUBLIC_BASE_URL}/l/${log.public_id}`;

//     try {
//       await navigator.clipboard.writeText(shareUrl);
//       alert("Public share link copied");
//     } catch (err) {
//       console.error(err);
//       alert("Failed to copy link");
//     }
//   };

//   // 📝 Add note (OWNER ACTION)
//   const handleAddNote = async () => {
//     if (!note.trim()) return;

//     const ref = await addDoc(collection(db, "log_events"), {
//       log_id: logId,
//       event_type: "NOTE_ADDED",
//       actor: auth.currentUser.uid,
//       timestamp: serverTimestamp(),
//       metadata: { note },
//     });

//     setEvents((prev) => [
//       ...prev,
//       {
//         id: ref.id,
//         log_id: logId,
//         event_type: "NOTE_ADDED",
//         actor: auth.currentUser.uid,
//         timestamp: { toDate: () => new Date() },
//         metadata: { note },
//       },
//     ]);

//     setNote("");
//   };

//   // 📄 Export PDF (OWNER ACTION)
//   const handleExportPDF = async () => {
//     const pdf = new jsPDF();

//     pdf.text(`Log: ${log.title}`, 10, 20);
//     pdf.text(`Created: ${formatDate(log.created_at)}`, 10, 30);
//     pdf.text(`Expires: ${formatDate(log.expiry_at)}`, 10, 40);

//     let y = 60;
//     events.forEach((e) => {
//       pdf.text(`${e.event_type} — ${formatDate(e.timestamp)}`, 10, y);
//       y += 10;
//     });

//     pdf.save(`log-${log.id}.pdf`);

//     const ref = await addDoc(collection(db, "log_events"), {
//       log_id: logId,
//       event_type: "EXPORTED",
//       actor: auth.currentUser.uid,
//       timestamp: serverTimestamp(),
//     });

//     setEvents((prev) => [
//       ...prev,
//       {
//         id: ref.id,
//         log_id: logId,
//         event_type: "EXPORTED",
//         actor: auth.currentUser.uid,
//         timestamp: { toDate: () => new Date() },
//       },
//     ]);
//   };

//   if (loading) return <p style={{ padding: 40 }}>Loading…</p>;
//   if (error) return <p style={{ padding: 40, color: "red" }}>{error}</p>;

//   return (
//     <div className="signup-wrapper">
//       <div className="yellow-circle"></div>

//       <div className="signup-card log-detail-card">
//         <h1>{log.title}</h1>

//         <div className="meta">
//           <p><strong>Created:</strong> {formatDate(log.created_at)}</p>
//           <p><strong>Expires:</strong> {formatDate(log.expiry_at)}</p>

//           {/* 🟢 Debug-safe public link display (optional) */}
//           <p>
//             <strong>Public Link:</strong>{" "}
//             <code>{`${PUBLIC_BASE_URL}/l/${log.public_id}`}</code>
//           </p>
//         </div>

//         <hr />

//         <h3>Timeline</h3>

//         <ul className="timeline">
//           {events.map((e) => (
//             <li key={e.id}>
//               <strong>{e.event_type}</strong>
//               <span>{formatDate(e.timestamp)}</span>
//               {e.metadata?.note && (
//                 <div className="note-box">{e.metadata.note}</div>
//               )}
//             </li>
//           ))}
//         </ul>

//         <div className="actions">
//           <button onClick={handleShare}>Share Link</button>
//           <button onClick={handleExportPDF}>Export PDF</button>
//         </div>

//         <div className="input-group">
//           <textarea
//             className="note-input"
//             placeholder="Add a note"
//             value={note}
//             onChange={(e) => setNote(e.target.value)}
//           />
//         </div>

//         <button className="signup-btn" onClick={handleAddNote}>
//           Add Note
//         </button>
//       </div>
//     </div>
//   );
// }

// // 🔹 Helper
// function formatDate(ts) {
//   if (!ts) return "—";
//   return ts.toDate().toLocaleString();
// }















import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  orderBy,
  getDocs,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";
import { auth, db } from "../firebase";
import jsPDF from "jspdf";
import "./LogDetail.css";

const PUBLIC_BASE_URL = "https://prooftap-f7ca4.web.app";

export default function LogDetail() {
  const { logId } = useParams();

  const [log, setLog] = useState(null);
  const [events, setEvents] = useState([]);
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        const logSnap = await getDoc(doc(db, "logs", logId));
        if (!logSnap.exists()) throw new Error("Log not found");

        const logData = { id: logSnap.id, ...logSnap.data() };
        if (!logData.public_id)
          throw new Error("Public link missing");

        setLog(logData);

        const q = query(
          collection(db, "log_events"),
          where("log_id", "==", logId),
          orderBy("timestamp", "asc")
        );
        const snap = await getDocs(q);
        setEvents(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [logId]);

  /* ===============================
     PDF EXPORT (PRO GRADE)
  =============================== */

  const handleExportPDF = async () => {
    const pdf = new jsPDF();
    let y = 20;

    const line = () => {
      pdf.setDrawColor(200);
      pdf.line(10, y, 200, y);
      y += 6;
    };

    const text = (t, size = 11, bold = false) => {
      pdf.setFontSize(size);
      pdf.setFont("helvetica", bold ? "bold" : "normal");
      pdf.text(t, 10, y);
      y += size + 2;
    };

    // HEADER
    text("LogitOnce — Evidence Record", 16, true);
    text(log.title, 13, true);
    line();

    // METADATA
    text("Metadata", 13, true);
    text(`Log ID: ${log.id}`);
    text(`Public ID: ${log.public_id}`);
    text(`Created at: ${fmt(log.created_at)}`);
    text(`Expiry at: ${fmt(log.expiry_at)}`);
    text(`Exported at: ${new Date().toLocaleString()}`);
    line();

    // FINAL STATUS
    const finalEvent = events.find(e =>
      ["ACKNOWLEDGED", "DISPUTED", "NO_RESPONSE"].includes(e.event_type)
    );

    text("Final Outcome", 13, true);
    text(
      finalEvent
        ? finalEvent.event_type.replace("_", " ")
        : "PENDING"
    );

    if (finalEvent?.metadata?.verification) {
      text(`Verification: ${finalEvent.metadata.verification}`);
    }

    if (finalEvent) {
      text(`Responded at: ${fmt(finalEvent.timestamp)}`);
    }
    line();

    // TIMELINE
    text("Timeline (Append-Only)", 13, true);

    events.forEach(ev => {
      text(
        `• ${ev.event_type} — ${fmt(ev.timestamp)}`,
        10,
        true
      );

      if (ev.metadata?.note) {
        text(`  Note: ${ev.metadata.note}`, 10);
      }
      if (ev.metadata?.reason) {
        text(`  Reason: ${ev.metadata.reason}`, 10);
      }
      if (ev.metadata?.comment) {
        text(`  Comment: ${ev.metadata.comment}`, 10);
      }
      y += 2;
    });

    line();

    // FOOTER
    pdf.setFontSize(9);
    pdf.text(
      "This document is system-generated, immutable, and timestamped.\nGenerated by LogitOnce.",
      10,
      280
    );

    pdf.save(`log-${log.id}.pdf`);

    // RECORD EXPORT EVENT
    await addDoc(collection(db, "log_events"), {
      log_id: logId,
      event_type: "EXPORTED",
      actor: auth.currentUser.uid,
      timestamp: serverTimestamp(),
    });
  };

  /* =============================== */

  if (loading) return <p style={{ padding: 40 }}>Loading…</p>;
  if (error) return <p style={{ padding: 40, color: "red" }}>{error}</p>;

  return (
    <div className="signup-wrapper">
      <div className="yellow-circle"></div>

      <div className="signup-card log-detail-card">
        <h1>{log.title}</h1>

        <p><b>Created:</b> {fmt(log.created_at)}</p>
        <p><b>Expires:</b> {fmt(log.expiry_at)}</p>
        <p>
          <b>Public link:</b>{" "}
          <code>{`${PUBLIC_BASE_URL}/l/${log.public_id}`}</code>
        </p>

        <hr />

        <h3>Timeline</h3>
        <ul className="timeline">
          {events.map(e => (
            <li key={e.id}>
              <b>{e.event_type}</b>
              <span>{fmt(e.timestamp)}</span>
            </li>
          ))}
        </ul>

        <div className="actions">
          <button onClick={handleExportPDF}>Export PDF</button>
        </div>

        <textarea
          className="note-input"
          placeholder="Add a note"
          value={note}
          onChange={e => setNote(e.target.value)}
        />
      </div>
    </div>
  );
}

/* ===============================
   HELPERS
=============================== */

function fmt(ts) {
  if (!ts) return "—";
  return ts.toDate().toLocaleString();
}
